<template>
  <div>
    <div class="globe_footer">
      <div class="globe_footer_bar EC_width">
        <div class="footer_logo" @click="tofmch" style="cursor: pointer;">
          <img src="@/assets/img/login/en_logoFooter.jpg" style="height: 100%" />
        </div>
        <div class="footer_text">
          <div class="">
            <span class="marginRight20">Telphone：（010）- 83116369</span>
            <span>E-mail: managingeditor@fmch.net.cn</span>
          </div>
          <div>
            <span>BMJ:
              <a style="color: #b7c7e0;" href="https://fmch.bmj.com" target="_blank">
                https://fmch.bmj.com
              </a></span>
            <span>，Facebook:
              <a style="color: #b7c7e0;" href="https://www.facebook.com/fmch.journal" target="_blank">
                https://www.facebook.com/fmch.journal
              </a></span>
          </div>
          <div>
            <span>Twitter:
              <a style="color: #b7c7e0;"  target="_blank">
                BMJ_FMCH@163.com
              </a></span>
          </div>
          <div class="footer_text_down">
            <span>Adress：Room 907, Beijing A, Guangyi Building, No.5 Guangyi Street, Xicheng District, Beijing</span>
          </div>
        </div>
        <div class="footer_icon">
          <a href="#" class="footer_icon_link"><img src="/image/footericon/icon1.png" /></a>
          <a href="#" class="footer_icon_link"><img src="/image/footericon/icon2.png" /></a>
          <a href="#" class="footer_icon_link"><img src="/image/footericon/icon3.png" /></a>
          <a href="#" class="footer_icon_link"><img src="/image/footericon/icon4.png" /></a>
          <a href="#" class="footer_icon_link"><img src="/image/footericon/icon5.png" /></a>
          <a href="#" class="footer_icon_link"><img src="/image/footericon/icon6.png" /></a>
        </div>
      </div>
    </div>
    <div class="globe_footer_beian">
      <div class="EC_width">
        <span style="border-right: 1px solid #7B889B; padding-right: 10px;margin-right: 10px;">© Copyright 2023 Beijing
          Huaweitongke Health Technology Co., Ltd. All rights reserved </span>
        <a href="https://beian.miit.gov.cn" target="_blank">
          <span style="border-right: 1px solid #7B889B; padding-right: 10px;margin-right: 10px; color: #7b889b;">
            Beijing ICP No. 2021015394 -1 </span>
        </a>
        <span> <img src="/image/footericon/gongan.png" /> Beijing public security network 11010202009427 .</span>
        <!-- <img src="/image/footericon/line.png" /> -->
      </div>
    </div>
    <div class="globe_footer_beian">
      <div class="EC_width">
        <span
          style="border-right: 1px solid #7B889B; padding-right: 9px;margin-right: 10px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Beijing
          Huawei General Practice Research Institute
          (BHGPRI)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <a href="https://fmch.bmj.com/pages/authors/" target="_blank">
          <span style="border-right: 1px solid #7B889B; padding-right: 10px;margin-right: 10px; color: #7b889b;">
            Instructions for authors </span>
        </a>
        <a href="https://mc.manuscriptcentral.com/fmchj?_gl=1*1seuj6c*_ga*NzA5NTk1NTY3LjE2ODg1NDAzMDA.*_ga_EXTSVLH45V*MTY4OTgyMjYwNS4yLjEuMTY4OTgyMzMyNC4wLjAuMA..*_fplc*dE5tTXBCNzU2OWVMc21uV0cycUJFdEQ2bWtqUjBGeHA1VUg1NDFoamlFeUIwTUpOUVFreEd2cExZY3FJaHlzQ1ROdWxIY1NYRCUyRkJYMTd1Zm1rSmE0UmhrdkE2dCUyQk41UmdFaHVETUd4MTFIU0lUUDVHQTNCanRRSXlNZ05UUSUzRCUzRA.."
          target="_blank">
          <span style="border-right: 1px solid #7B889B; padding-right: 10px;margin-right: 10px; color: #7b889b;"> Submit
            an article </span>
        </a>
        <a href="https://www.bmj.com/company/openaccess/?_gl=1*13g2gn6*_ga*NzA5NTk1NTY3LjE2ODg1NDAzMDA.*_ga_EXTSVLH45V*MTY4OTgyMjYwNS4yLjEuMTY4OTgyMzYzMC4wLjAuMA..*_fplc*dE5tTXBCNzU2OWVMc21uV0cycUJFdEQ2bWtqUjBGeHA1VUg1NDFoamlFeUIwTUpOUVFreEd2cExZY3FJaHlzQ1ROdWxIY1NYRCUyRkJYMTd1Zm1rSmE0UmhrdkE2dCUyQk41UmdFaHVETUd4MTFIU0lUUDVHQTNCanRRSXlNZ05UUSUzRCUzRA.."
          target="_blank">
          <span style="padding-right: 10px;margin-right: 10px; color: #7b889b;"> Open Access at BMJ </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "en_footer",
  data() {
    return {};
  },
  methods: {
    tofmch() {
      window.open("https://fmch.bmj.com", "_blank");
    }
  }
}
</script>

<style scoped></style>
